import { render } from "./AntifrodeMainPage.vue?vue&type=template&id=a698ae22"
import script from "./AntifrodeMainPage.vue?vue&type=script&lang=js"
export * from "./AntifrodeMainPage.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__